import http from '@/utils/http'
import { PATH_ACCREDIT } from '@/utils/consts'
import {
  RegistrationPostReq,
  RegistrationGetReq,
  CertificationGetReq,
  CheckReq,
  GradeReq,
} from './types/accredit'

// 认证评测报名请求
export const postRegistration = (data: RegistrationPostReq) => {
  return http.post(`${PATH_ACCREDIT}/v1/registration`, data)
}

// 认证评测报名查询
export const getRegistration = (data: RegistrationGetReq) => {
  return http.get(`${PATH_ACCREDIT}/v1/registration`, data)
}

// 认证评测报名查询
export const getRegistrationById = (id: number) => {
  return http.get(`${PATH_ACCREDIT}/v1/registration/id`, { id })
}

// 评测证书查询请求
export const getCertification = (data: CertificationGetReq) => {
  return http.get(`${PATH_ACCREDIT}/v1/certification`, data)
}

// 评测证书查询请求
export const checkCanRegistration = (data: CheckReq) => {
  return http.get(`${PATH_ACCREDIT}/v1/check`, data)
}

// 评测级别信息查询
export const getRegistrationGradeInfo = (data: GradeReq) => {
  return http.get(`${PATH_ACCREDIT}/v1/grade`, data)
}
